import { GiveawayContributionApiClient } from '@fourthwall/services/dist/GiveawayContributionApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useGiveawayContributionCostsBreakdownQuery = createQueryHook(
  GiveawayContributionApiClient.getGiveawayContributionCostsBreakdown,
  {
    queryKey: ['giveawayContributionCostsBreakdown'],
  },
)
